import { render, staticRenderFns } from "./ModalSignaturev2.vue?vue&type=template&id=4b09bc08&"
import script from "./ModalSignaturev2.vue?vue&type=script&lang=js&"
export * from "./ModalSignaturev2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports